import type { CitationInput } from "./seo";

export const ARTICLE_CITATIONS: Record<string, CitationInput[]> = {
  "why-we-present-care-as-five-options-not-one": [
    {
      name: "Ghost Networks of Psychiatrists Make it Hard for Consumers to Get Treatment (US Senate Finance Committee staff report)",
      author: "US Senate Committee on Finance",
      datePublished: "2023-12-01",
      url: "https://www.finance.senate.gov/imo/media/doc/12062023_ghost_network_report.pdf",
      journal: "US Senate Finance Committee",
    },
    {
      name: "Acceptance of Insurance by Psychiatrists and the Implications for Access to Mental Health Care",
      author: "Bishop TF, Press MJ, Keyhani S, Pincus HA",
      datePublished: "2014",
      url: "https://pubmed.ncbi.nlm.nih.gov/24337499/",
      journal: "JAMA Psychiatry",
    },
    {
      name: "Collaborative Care Management of Late-Life Depression in the Primary Care Setting (IMPACT trial)",
      author: "Unützer J, Katon W, Callahan CM, et al.",
      datePublished: "2002",
      url: "https://pubmed.ncbi.nlm.nih.gov/12472325/",
      journal: "JAMA",
    },
    {
      name: "Mental Illness statistics — adults with any mental illness, treatment gap",
      author: "National Institute of Mental Health",
      datePublished: "2024",
      url: "https://www.nimh.nih.gov/health/statistics/mental-illness",
      journal: "NIMH statistics",
    },
    {
      name: "Behavioral Health Workforce Projections, 2020-2035 — psychiatrist supply and demand",
      author: "Health Resources and Services Administration",
      datePublished: "2023",
      url: "https://bhw.hrsa.gov/data-research/projecting-health-workforce-supply-demand",
      journal: "HRSA Health Workforce Analysis",
    },
    {
      name: "988 Suicide and Crisis Lifeline — program description and performance data",
      author: "Substance Abuse and Mental Health Services Administration",
      datePublished: "2024",
      url: "https://www.samhsa.gov/find-help/988",
      journal: "SAMHSA",
    },
    {
      name: "Ghost networks in mental health care — a persistent barrier to access",
      author: "Melek SP, Norris DT, Paulus J",
      datePublished: "2023",
      url: "https://www.milbank.org/publications/",
      journal: "Milbank Memorial Fund",
    },
    {
      name: "Physician Appointment Wait Times and Medicaid and Medicare Acceptance Rates (2022 survey)",
      author: "Merritt Hawkins",
      datePublished: "2022",
      url: "https://www.merritthawkins.com/uploadedFiles/MerrittHawkins_2022_WaitTimeSurvey.pdf",
      journal: "Merritt Hawkins",
    },
    {
      name: "Behavioral Health Treatment Services Locator",
      author: "Substance Abuse and Mental Health Services Administration",
      datePublished: "2024",
      url: "https://findtreatment.gov/",
      journal: "SAMHSA",
    },
  ],

  "why-your-mind-feels-loudest-when-trying-to-rest": [
    {
      name: "The hyperarousal model of insomnia: a review of the concept and its evidence",
      author: "Riemann D, Spiegelhalder K, Feige B, et al.",
      datePublished: "2010",
      url: "https://pubmed.ncbi.nlm.nih.gov/19481481/",
      journal: "Sleep Medicine Reviews",
    },
    {
      name: "Insomnia: conceptual issues in the development, persistence, and treatment of sleep disorder in adults",
      author: "Espie CA",
      datePublished: "2002",
      url: "https://pubmed.ncbi.nlm.nih.gov/11752482/",
      journal: "Annual Review of Psychology",
    },
    {
      name: "Hyperarousal and insomnia: state of the science",
      author: "Bonnet MH, Arand DL",
      datePublished: "2010",
      url: "https://pubmed.ncbi.nlm.nih.gov/19945294/",
      journal: "Sleep Medicine Reviews",
    },
    {
      name: "Sleep deprivation and deficiency",
      author: "National Heart, Lung, and Blood Institute (NIH)",
      datePublished: "2022",
      url: "https://www.nhlbi.nih.gov/health/sleep-deprivation",
    },
    {
      name: "Caffeine effects on sleep taken 0, 3, or 6 hours before going to bed",
      author: "Drake C, Roehrs T, Shambroom J, Roth T",
      datePublished: "2013",
      url: "https://pubmed.ncbi.nlm.nih.gov/24235903/",
      journal: "Journal of Clinical Sleep Medicine",
    },
    {
      name: "Cognitive behavioral therapy for insomnia",
      author: "American Academy of Sleep Medicine",
      datePublished: "2021",
      url: "https://aasm.org/clinical-resources/practice-standards/practice-guidelines/",
    },
  ],
  "why-thinking-harder-usually-makes-anxiety-worse": [
    {
      name: "The role of rumination in depressive disorders and mixed anxiety/depressive symptoms",
      author: "Nolen-Hoeksema S",
      datePublished: "2000",
      url: "https://pubmed.ncbi.nlm.nih.gov/11061581/",
      journal: "Journal of Abnormal Psychology",
    },
    {
      name: "Paradoxical effects of thought suppression",
      author: "Wegner DM, Schneider DJ, Carter SR, White TL",
      datePublished: "1987",
      url: "https://pubmed.ncbi.nlm.nih.gov/3612492/",
      journal: "Journal of Personality and Social Psychology",
    },
    {
      name: "Metacognitive therapy for anxiety and depression",
      author: "Wells A",
      datePublished: "2009",
      url: "https://www.guilford.com/books/Metacognitive-Therapy-for-Anxiety-and-Depression/Adrian-Wells/9781609184964",
      journal: "Guilford Press",
    },
    {
      name: "Practice guideline for the treatment of patients with generalized anxiety disorder",
      author: "American Psychiatric Association",
      datePublished: "2024",
      url: "https://psychiatry.org/psychiatrists/practice/clinical-practice-guidelines",
    },
    {
      name: "Rethinking rumination",
      author: "Nolen-Hoeksema S, Wisco BE, Lyubomirsky S",
      datePublished: "2008",
      url: "https://pubmed.ncbi.nlm.nih.gov/26158958/",
      journal: "Perspectives on Psychological Science",
    },
    {
      name: "Cognitive behavioral therapy for adult anxiety disorders: a meta-analysis of randomized placebo-controlled trials",
      author: "Hofmann SG, Smits JA",
      datePublished: "2008",
      url: "https://pubmed.ncbi.nlm.nih.gov/18363421/",
      journal: "Journal of Clinical Psychiatry",
    },
  ],
  "why-your-brain-replays-conversations-long-after-they-end": [
    {
      name: "Why rejection hurts: a common neural alarm system for physical and social pain",
      author: "Eisenberger NI, Lieberman MD",
      datePublished: "2004",
      url: "https://pubmed.ncbi.nlm.nih.gov/15242688/",
      journal: "Trends in Cognitive Sciences",
    },
    {
      name: "A cognitive model of social phobia",
      author: "Clark DM, Wells A",
      datePublished: "1995",
      url: "https://psycnet.apa.org/record/1995-99005-004",
      journal: "Social Phobia: Diagnosis, Assessment, and Treatment",
    },
    {
      name: "An analysis of post-event processing in social anxiety disorder",
      author: "Brozovich F, Heimberg RG",
      datePublished: "2008",
      url: "https://pubmed.ncbi.nlm.nih.gov/18403081/",
      journal: "Clinical Psychology Review",
    },
    {
      name: "Post-event processing in social anxiety: a systematic review and meta-analysis",
      author: "Wong QJJ, Moulds ML",
      datePublished: "2017",
      url: "https://pubmed.ncbi.nlm.nih.gov/27770654/",
      journal: "Clinical Psychology Review",
    },
    {
      name: "The neural correlates of social pain: a meta-analysis",
      author: "Cacioppo S, Frum C, Asp E, Weiss RM, Lewis JW, Cacioppo JT",
      datePublished: "2013",
      url: "https://pubmed.ncbi.nlm.nih.gov/24008248/",
      journal: "Scientific Reports",
    },
    {
      name: "Rumination as a mediator of the relationship between social anxiety and post-event processing",
      author: "Kashdan TB, Roberts JE",
      datePublished: "2007",
      url: "https://pubmed.ncbi.nlm.nih.gov/16979335/",
      journal: "Journal of Anxiety Disorders",
    },
  ],
  "why-high-performers-can-still-feel-anxious": [
    {
      name: "Stress, adaptation, and disease: allostasis and allostatic load",
      author: "McEwen BS",
      datePublished: "1998",
      url: "https://pubmed.ncbi.nlm.nih.gov/9629234/",
      journal: "Annals of the New York Academy of Sciences",
    },
    {
      name: "Understanding the burnout experience: recent research and its implications for psychiatry",
      author: "Maslach C, Leiter MP",
      datePublished: "2016",
      url: "https://pubmed.ncbi.nlm.nih.gov/27265691/",
      journal: "World Psychiatry",
    },
    {
      name: "Why Zebras Don't Get Ulcers",
      author: "Sapolsky RM",
      datePublished: "2004",
      url: "https://us.macmillan.com/books/9780805073690/whyzebrasdontgetulcers",
      journal: "Henry Holt and Company",
    },
    {
      name: "Generalized anxiety disorder",
      author: "American Psychiatric Association",
      datePublished: "2024",
      url: "https://www.psychiatry.org/patients-families/anxiety-disorders/what-are-anxiety-disorders",
    },
    {
      name: "Allostatic load biomarkers of chronic stress and impact on health and cognition",
      author: "Juster RP, McEwen BS, Lupien SJ",
      datePublished: "2010",
      url: "https://pubmed.ncbi.nlm.nih.gov/19822172/",
      journal: "Neuroscience and Biobehavioral Reviews",
    },
    {
      name: "Perfectionism and mental health: a meta-analysis",
      author: "Limburg K, Watson HJ, Hagger MS, Egan SJ",
      datePublished: "2017",
      url: "https://pubmed.ncbi.nlm.nih.gov/27741357/",
      journal: "Journal of Clinical Psychology",
    },
  ],
  "why-your-nervous-system-thinks-everything-is-urgent": [
    {
      name: "Why Zebras Don't Get Ulcers",
      author: "Sapolsky RM",
      datePublished: "2004",
      url: "https://us.macmillan.com/books/9780805073690/whyzebrasdontgetulcers",
      journal: "Henry Holt and Company",
    },
    {
      name: "The polyvagal theory: phylogenetic substrates of a social nervous system",
      author: "Porges SW",
      datePublished: "2001",
      url: "https://pubmed.ncbi.nlm.nih.gov/11587772/",
      journal: "International Journal of Psychophysiology",
    },
    {
      name: "Toward an understanding of the biology of polyvagal theory: a comment on Porges",
      author: "Grossman P, Taylor EW",
      datePublished: "2007",
      url: "https://pubmed.ncbi.nlm.nih.gov/17239520/",
      journal: "Biological Psychology",
    },
    {
      name: "Interoception and emotion",
      author: "Critchley HD, Garfinkel SN",
      datePublished: "2017",
      url: "https://pubmed.ncbi.nlm.nih.gov/29050691/",
      journal: "Current Opinion in Psychology",
    },
    {
      name: "Allostasis and the autonomic nervous system: balancing function and allostatic load",
      author: "McEwen BS, Wingfield JC",
      datePublished: "2003",
      url: "https://pubmed.ncbi.nlm.nih.gov/12614636/",
      journal: "Hormones and Behavior",
    },
    {
      name: "Heart rate variability: a new way to track well-being",
      author: "Shaffer F, Ginsberg JP",
      datePublished: "2017",
      url: "https://pubmed.ncbi.nlm.nih.gov/29034226/",
      journal: "Frontiers in Public Health",
    },
  ],
  "difference-between-a-thought-and-thinking": [
    {
      name: "Acceptance and Commitment Therapy: An Experiential Approach to Behavior Change",
      author: "Hayes SC, Strosahl KD, Wilson KG",
      datePublished: "1999",
      url: "https://www.guilford.com/books/Acceptance-and-Commitment-Therapy/Hayes-Strosahl-Wilson/9781462528943",
      journal: "Guilford Press",
    },
    {
      name: "Acceptance and mindfulness-based therapy: new wave or old hat?",
      author: "Hofmann SG, Asmundson GJ",
      datePublished: "2008",
      url: "https://pubmed.ncbi.nlm.nih.gov/17904260/",
      journal: "Clinical Psychology Review",
    },
    {
      name: "Brain meta-state transitions demarcate thoughts across task contexts exposing the mental noise of trait neuroticism",
      author: "Tseng J, Poppenk J",
      datePublished: "2020",
      url: "https://pubmed.ncbi.nlm.nih.gov/32641669/",
      journal: "Nature Communications",
    },
    {
      name: "Cognitive defusion versus cognitive restructuring in the treatment of negative self-referential thoughts",
      author: "Deacon BJ, Fawzy TI, Lickel JJ, Wolitzky-Taylor KB",
      datePublished: "2011",
      url: "https://pubmed.ncbi.nlm.nih.gov/21338958/",
      journal: "Journal of Cognitive Psychotherapy",
    },
    {
      name: "Mindfulness-based cognitive therapy for the prevention of depressive relapse",
      author: "Kuyken W, Warren FC, Taylor RS, et al.",
      datePublished: "2016",
      url: "https://pubmed.ncbi.nlm.nih.gov/27119968/",
      journal: "JAMA Psychiatry",
    },
    {
      name: "Practice guideline for the treatment of patients with obsessive-compulsive disorder",
      author: "American Psychiatric Association",
      datePublished: "2024",
      url: "https://psychiatry.org/psychiatrists/practice/clinical-practice-guidelines",
    },
  ],
  "why-popular-mental-health-commentary-falls-short-in-the-moment": [
    {
      name: "Putting feelings into words: affect labeling disrupts amygdala activity in response to affective stimuli",
      author: "Lieberman MD, Eisenberger NI, Crockett MJ, Tom SM, Pfeifer JH, Way BM",
      datePublished: "2007",
      url: "https://pubmed.ncbi.nlm.nih.gov/17576282/",
      journal: "Psychological Science",
    },
    {
      name: "Stress signalling pathways that impair prefrontal cortex structure and function",
      author: "Arnsten AFT",
      datePublished: "2009",
      url: "https://pubmed.ncbi.nlm.nih.gov/19455173/",
      journal: "Nature Reviews Neuroscience",
    },
    {
      name: "Cognitive behavioral therapy for adult anxiety disorders: a meta-analysis of randomized placebo-controlled trials",
      author: "Hofmann SG, Smits JA",
      datePublished: "2008",
      url: "https://pubmed.ncbi.nlm.nih.gov/18363421/",
      journal: "Journal of Clinical Psychiatry",
    },
    {
      name: "Treatment of post-traumatic stress disorder",
      author: "American Psychological Association",
      datePublished: "2017",
      url: "https://www.apa.org/ptsd-guideline",
    },
    {
      name: "Acceptance and Commitment Therapy: An Experiential Approach to Behavior Change",
      author: "Hayes SC, Strosahl KD, Wilson KG",
      datePublished: "1999",
      url: "https://www.guilford.com/books/Acceptance-and-Commitment-Therapy/Hayes-Strosahl-Wilson/9781462528943",
      journal: "Guilford Press",
    },
    {
      name: "Misinformation about mental illness in popular media: implications for public understanding",
      author: "Stuart H",
      datePublished: "2006",
      url: "https://pubmed.ncbi.nlm.nih.gov/16881956/",
      journal: "Canadian Journal of Psychiatry",
    },
  ],
  "what-modern-psychiatry-gets-right": [
    {
      name: "The NIMH Research Domain Criteria (RDoC) Project: precision medicine for psychiatry",
      author: "Insel TR",
      datePublished: "2014",
      url: "https://pubmed.ncbi.nlm.nih.gov/24687194/",
      journal: "American Journal of Psychiatry",
    },
    {
      name: "The efficacy of psychotherapies and pharmacotherapies for mental disorders in adults: an umbrella review and meta-analytic evaluation of recent meta-analyses",
      author: "Cuijpers P, Karyotaki E, de Wit L, Ebert DD",
      datePublished: "2020",
      url: "https://pubmed.ncbi.nlm.nih.gov/32931110/",
      journal: "World Psychiatry",
    },
    {
      name: "APA Practice Guidelines for the treatment of patients with major depressive disorder",
      author: "American Psychiatric Association",
      datePublished: "2024",
      url: "https://psychiatry.org/psychiatrists/practice/clinical-practice-guidelines",
    },
    {
      name: "Lifetime prevalence and age-of-onset distributions of mental disorders in the World Health Organization's World Mental Health Survey Initiative",
      author: "Kessler RC, Aguilar-Gaxiola S, Alonso J, et al.",
      datePublished: "2007",
      url: "https://pubmed.ncbi.nlm.nih.gov/18188442/",
      journal: "World Psychiatry",
    },
    {
      name: "Efficacy and safety of antidepressants for the acute treatment of major depressive disorder: a systematic review and network meta-analysis",
      author: "Cipriani A, Furukawa TA, Salanti G, et al.",
      datePublished: "2018",
      url: "https://pubmed.ncbi.nlm.nih.gov/29477251/",
      journal: "The Lancet",
    },
    {
      name: "Global, regional, and national burden of 12 mental disorders in 204 countries and territories, 1990-2019",
      author: "GBD 2019 Mental Disorders Collaborators",
      datePublished: "2022",
      url: "https://pubmed.ncbi.nlm.nih.gov/35026139/",
      journal: "The Lancet Psychiatry",
    },
  ],
  "digital-mental-health-needs-more-than-convenience": [
    {
      name: "The effectiveness of telemental health: a 2013 review",
      author: "Hilty DM, Ferrer DC, Parish MB, Johnston B, Callahan EJ, Yellowlees PM",
      datePublished: "2013",
      url: "https://pubmed.ncbi.nlm.nih.gov/23697504/",
      journal: "Telemedicine and e-Health",
    },
    {
      name: "Telemedicine in psychiatry: an overview of the literature",
      author: "Yellowlees P, Shore J, Roberts L",
      datePublished: "2010",
      url: "https://pubmed.ncbi.nlm.nih.gov/20932066/",
      journal: "Telemedicine and e-Health",
    },
    {
      name: "Policy for device software functions and mobile medical applications",
      author: "U.S. Food and Drug Administration",
      datePublished: "2019",
      url: "https://www.fda.gov/regulatory-information/search-fda-guidance-documents/policy-device-software-functions-and-mobile-medical-applications",
    },
    {
      name: "General wellness: policy for low risk devices",
      author: "U.S. Food and Drug Administration",
      datePublished: "2019",
      url: "https://www.fda.gov/regulatory-information/search-fda-guidance-documents/general-wellness-policy-low-risk-devices",
    },
    {
      name: "Telehealth use and overdose mortality risk among Medicare beneficiaries with opioid use disorder",
      author: "Jones CM, Shoff C, Hodges K, et al.",
      datePublished: "2022",
      url: "https://pubmed.ncbi.nlm.nih.gov/36103219/",
      journal: "JAMA Psychiatry",
    },
    {
      name: "Direct-to-consumer telehealth services for ADHD: a call for quality, safety, and regulatory oversight",
      author: "Adler LA, Anbarasan D",
      datePublished: "2023",
      url: "https://pubmed.ncbi.nlm.nih.gov/37672275/",
      journal: "JAMA Psychiatry",
    },
  ],
};
